/**
 * List of query params that should be skipped when building the redirect URL
 */
const SKIPPED_REDIRECT_QUERY_PARAMS = ["response_source"];

/**
 * Build a redirect URL with the search params, skipping the skipped query params
 */
export const buildRedirectUrl = ({
	url,
	searchParams,
}: Readonly<{url: string; searchParams: URLSearchParams}>): string => {
	const filteredSearchParams = new URLSearchParams(searchParams);

	SKIPPED_REDIRECT_QUERY_PARAMS.forEach(param => {
		filteredSearchParams.delete(param);
	});

	const searchString = filteredSearchParams.toString();

	if (!searchString) {
		return url;
	}

	const separator = url.includes("?") ? "&" : "?";
	return `${url}${separator}${searchString}`;
};
